import Filter from './filter';
import { computeCurrencyMaxCharCount, computeNumberMaxCharCount, computePercentageMaxCharCount } from "@/utils/transformers";
import { computeMinMax, transformWithCountries } from "@/utils";
import { request } from "@/store";
import moment from "moment";
import { FLOATING_COMPOUND_TABLE_STATES, GROUP_BY_TAB_ELEMENTS, APP_PERIOD_DROPDOWN_ELEMENTS } from "@/utils/constants";
import { DATE_PICKER_RANGE_TITLES } from '../utils/datepicker';
import { Currencies } from '../utils/currencies';
import { PERIOD_OPTIONS, PERIOD_OPTIONS_V2 } from '../utils/constants';
import { COMPONENTS, DEFAULT_SCOPES, Kpi, createCurrentPeriodViewFromData } from '@/utils/dashboard/current_period';
const DEFAULT_EMPTY_ROW_SIZE = 20;
const dsp_report = {
  state: {
    sellers_filter: new Filter([], []),
    marketplaces_filter: new Filter([], [], "sales_channel"),
    line_items: new Filter([], [], "line_item_id"),
    campaigns: new Filter([], [], "order_id"),
    currencies: new Filter(Currencies, [], "symbol"),
    period: APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value,
    periodSelectorOptions: [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY, APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY, APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY, APP_PERIOD_DROPDOWN_ELEMENTS.YEARLY],
    periodCategory: PERIOD_OPTIONS_V2[APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value].LEFT.queryKey,
    overview_period: APP_PERIOD_DROPDOWN_ELEMENTS.WEEK_TO_DATE.value,
    overviewPeriodSelectorOptions: [APP_PERIOD_DROPDOWN_ELEMENTS.YEAR_TO_DATE, APP_PERIOD_DROPDOWN_ELEMENTS.QUARTER_TO_DATE, APP_PERIOD_DROPDOWN_ELEMENTS.MONTH_TO_DATE, APP_PERIOD_DROPDOWN_ELEMENTS.WEEK_TO_DATE, APP_PERIOD_DROPDOWN_ELEMENTS.LAST_WEEK, APP_PERIOD_DROPDOWN_ELEMENTS.LAST_MONTH, APP_PERIOD_DROPDOWN_ELEMENTS.LAST_QUARTER],
    product_table: {
      state: FLOATING_COMPOUND_TABLE_STATES.INTERMEDIATE,
      group_by: 0,
      group_by_text: "",
      group_by_elements: [],
      conversion: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedSellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedMarketplaces"
          },
          line_item: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedLineItem"
          },
          campaign: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedCampaign"
          }
        }
      },
      consideration: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedSellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedMarketplaces"
          },
          line_item: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedLineItem"
          },
          campaign: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedCampaign"
          }
        }
      },
      loyalty: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedSellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedMarketplaces"
          },
          line_item: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedLineItem"
          },
          campaign: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              conversion_spend: "desc",
              consideration_spend: "desc",
              loyalty_spend: "desc"
            },
            fetch: "dspFetchReportGroupedCampaign"
          }
        }
      }
    },
    currentTab: 0,
    currentTabValue: "overview",
    tabs: [{
      text: "Overview",
      value: "overview",
      activeBg: "#FFF6F0",
      activeColor: "#E05E0F",
      feature: 'Overview'
    }, {
      separator: true
    }, {
      text: "Conversion",
      value: "conversion",
      activeBg: "#FFF6F0",
      activeColor: "#E05E0F",
      feature: 'dspConversion'
    }, {
      text: "Consideration",
      value: "consideration",
      activeBg: "#FFF6F0",
      activeColor: "#E05E0F",
      feature: 'dspConsideration'
    }, {
      text: "Loyalty",
      value: "loyalty",
      activeBg: "#FFF6F0",
      activeColor: "#E05E0F",
      feature: 'dspLoyalty'
    }],
    periodOptions: [PERIOD_OPTIONS.PREV_PERIOD, PERIOD_OPTIONS.SAME_PERIOD_LY],
    currentPeriod: {
      [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value]: {
        title: {
          prev_period: "Current week vs previous week",
          same_period_ly: "Current week vs same period last year"
        },
        format: "MMM D, YYYY",
        date: moment().startOf("isoWeek"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_WEEK,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: {
        title: {
          prev_period: "Current month vs previous month",
          same_period_ly: "Current month vs same period last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("month"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_MONTH,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: {
        title: {
          prev_period: "Current quarter vs previous quarter",
          same_period_ly: "Current quarter vs same period last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("quarter"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_QUARTER,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.YEARLY.value]: {
        title: {
          prev_period: "Current year vs previous year",
          same_period_ly: "Current year vs last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("year"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_YEAR,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      }
    },
    periodTable: {
      conversion: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      consideration: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      loyalty: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      period_page: 1
    },
    overviewTable: {
      items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
      maxCharCount: {},
      minMax: {}
    }
  },
  mutations: {
    dspSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    dspMarketplacesFilterSet(state, payload) {
      state.marketplaces_filter.restore(payload);
    },
    dspLineItemsFilterSet(state, payload) {
      state.line_items = payload;
    },
    dspCampaignsFilterSet(state, payload) {
      state.campaigns = payload;
    },
    dspSetPeriod(state, payload) {
      state.period = payload;
    },
    dspSetOverviewPeriod(state, payload) {
      state.overview_period = payload;
    },
    dspSetPeriodCategory(state, payload) {
      state.periodCategory = payload;
    },
    dspSetCurrentTab(state, payload) {
      const {
        tabIndex,
        tabValue
      } = payload;
      state.currentTab = tabIndex;
      state.currentTabValue = tabValue;
    },
    dspSetPeriodTableItems(state, payload) {
      state.periodTable['conversion'].items = payload;
      state.periodTable['consideration'].items = payload;
      state.periodTable['loyalty'].items = payload;
    },
    dspDeselectPeriodTable(state) {
      state.tabs.forEach(({
        value
      }) => {
        (state.periodTable[value]?.items ?? []).forEach(item => {
          item.selected = undefined;
        });
      });
    },
    dspSetOverviewTableItems(state, payload) {
      state.overviewTable.items = payload;
    },
    dspSetOverviewTableMinMax(state, payload) {
      state.overviewTable.minMax = payload;
    },
    dspSetOverviewTableMaxCharCount(state, payload) {
      state.overviewTable.maxCharCount = payload;
    },
    dspSetPeriodTableMinMax(state, payload) {
      state.periodTable['conversion'].minMax = payload;
      state.periodTable['consideration'].minMax = payload;
      state.periodTable['loyalty'].minMax = payload;
    },
    dspSetPeriodTableMaxCharCount(state, payload) {
      state.periodTable['conversion'].maxCharCount = payload;
      state.periodTable['consideration'].maxCharCount = payload;
      state.periodTable['loyalty'].maxCharCount = payload;
    },
    dspSetProductTableMinMax(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].minMax = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].minMax = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].minMax = payload;
    },
    dspSetProductTableTotal(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].total = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].total = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].total = payload;
    },
    dspSetProductTableTotalPages(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].totalPages = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].totalPages = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].totalPages = payload;
    },
    dspSetProductTablePage(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].page = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].page = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].page = payload;
    },
    dspSetProductTablePerPage(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].perPage = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].perPage = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].perPage = payload;
    },
    dspSetProductTableGroupBy(state, payload) {
      state.product_table.group_by = payload;
      state.product_table.group_by_text = state.product_table.group_by_elements[payload].key;
    },
    dspSetProductTablePeriod(state, payload) {
      state.product_table['conversion'].period = payload;
      state.product_table['consideration'].period = payload;
      state.product_table['loyalty'].period = payload;
    },
    dspSetProductTableItems(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].items = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].items = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].items = payload;
    },
    dspSetProductTableMaxCharCount(state, payload) {
      state.product_table['conversion'].data[state.product_table.group_by_text].maxCharCount = payload;
      state.product_table['consideration'].data[state.product_table.group_by_text].maxCharCount = payload;
      state.product_table['loyalty'].data[state.product_table.group_by_text].maxCharCount = payload;
    },
    dspSetProductTableState(state, payload) {
      state.product_table.state = payload;
    },
    dspSetProductTableGroupByElements(state, payload) {
      state.product_table.group_by_elements = payload;
    },
    dspSetProductTableSort(state, {
      sort,
      direction
    }) {
      state.product_table['conversion'].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
      state.product_table['consideration'].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
      state.product_table['loyalty'].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
    },
    dspIncrementPeriodPage(state) {
      state.periodTable.period_page += 1;
    },
    dspDefaultCurrencySet(state, payload) {
      // We need to update the currency filter
      state.currencies.selectOnly({
        symbol: payload
      }, 'symbol');
      state.currencies.apply();
    }
  },
  getters: {
    dspGetFilters(state) {
      return () => {
        return {
          seller_id: state.sellers_filter.filterValues,
          sales_channel: state.marketplaces_filter.selectedValues,
          line_item_list: state.line_items.selectedValues,
          order_list: state.campaigns.selectedValues
        };
      };
    },
    dspGetPeriod(state) {
      return () => state.period;
    },
    dspGetOverviewPeriod(state) {
      return () => state.overview_period;
    },
    dspGetPeriodCategory(state) {
      return () => state.periodCategory;
    },
    dspGetTab(state) {
      return () => state.currentTab;
    },
    dspGetTabValue(state) {
      return () => state.currentTab;
    },
    dspGetProductTablePage(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page;
    },
    dspGetProductTablePerPage(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage;
    },
    dspGetProductTableTotalPages(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.totalPages;
    },
    dspGetAccountState(state) {
      return () => {
        const res = {
          sellers: state.sellers_filter.defaultList,
          marketplaces: state.marketplaces_filter.defaultList
        };
        return res;
      };
    },
    dspGetProductTablePager(state) {
      return () => ({
        page: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page,
        page_size: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage
      });
    },
    dspGetProductTableGroupBy(state) {
      return () => state.product_table.group_by;
    },
    dspSingleMarketplace(state) {
      return () => {
        const filteredMarketplaces = state.marketplaces_filter.filterValues;
        return filteredMarketplaces.length === 1;
      };
    },
    dspGetPeriodOptions(state) {
      const currentPeriod = state.period;
      return [PERIOD_OPTIONS_V2[currentPeriod].LEFT, PERIOD_OPTIONS_V2[currentPeriod].RIGHT];
    },
    dspGetProductTableSort(state) {
      return () => {
        let obj = {
          sort_by: [],
          sort_direction: []
        };
        for (const [key, value] of Object.entries(state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.sort)) {
          obj['sort_by'].push(key);
          obj['sort_direction'].push(value);
        }
        return obj;
      };
    }
  },
  actions: {
    async dspFetchOverviewTableData({
      commit,
      getters,
      state
    }) {
      try {
        const params = {
          period: state.overview_period,
          ...getters.dspGetFilters(),
          ...getters.currencyConfigQueryGet(),
          ...getters.dateConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request('/ppc/dsp/overview', 'POST', params);
        let data = response.data;
        if (data) {
          commit("dspSetOverviewTableItems", data);
          commit('dspSetOverviewTableMaxCharCount', {
            number: computeNumberMaxCharCount(data),
            percentage: computePercentageMaxCharCount(data),
            currency: computeCurrencyMaxCharCount(data, full, currency, precision, showCurrencySign, false, limit)
          });
          commit("dspSetOverviewTableMinMax", computeMinMax(data));
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async dspFetchPeriodTableData({
      commit,
      getters,
      state
    }) {
      try {
        const params = {
          period: state.period,
          ...getters.dspGetFilters(),
          ...getters.currencyConfigQueryGet(),
          ...getters.dateConfigQueryGet(),
          period_page: state.periodTable.period_page
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request('/ppc/dsp/evolution', 'POST', params);
        let data = response.data;
        if (data) {
          commit("dspSetPeriodTableItems", data);
          commit('dspSetPeriodTableMaxCharCount', {
            number: computeNumberMaxCharCount(data),
            percentage: computePercentageMaxCharCount(data),
            currency: computeCurrencyMaxCharCount(data, full, currency, precision, showCurrencySign, false, limit)
          });
          commit("dspSetPeriodTableMinMax", computeMinMax(data));
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async dspFetchReportGroupedSellers({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.dspGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.dspGetFilters(),
          ...pager,
          ...getters.currencyConfigQueryGet(),
          ...getters.dspGetProductTableSort()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/dsp/report/seller", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('dspSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('dspSetProductTableItems', report);
            commit('dspSetProductTableTotal', total?.pop() ?? {});
            commit('dspSetProductTableMaxCharCount', {
              currency: computeCurrencyMaxCharCount(report, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report)
            });
            commit('dspSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async dspFetchReportGroupedMarketplaces({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.dspGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.dspGetFilters(),
          ...pager,
          ...getters.currencyConfigQueryGet(),
          ...getters.dspGetProductTableSort()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/dsp/report/marketplace", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('dspSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('dspSetProductTableItems', report);
            commit('dspSetProductTableTotal', total?.pop() ?? {});
            commit('dspSetProductTableMaxCharCount', {
              currency: computeCurrencyMaxCharCount(report, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report)
            });
            commit('dspSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async dspFetchReportGroupedLineItem({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.dspGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.dspGetFilters(),
          ...pager,
          ...getters.currencyConfigQueryGet(),
          ...getters.dspGetProductTableSort()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/dsp/report/line_item", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('dspSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('dspSetProductTableItems', report);
            commit('dspSetProductTableTotal', total?.pop() ?? {});
            commit('dspSetProductTableMaxCharCount', {
              currency: computeCurrencyMaxCharCount(report, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report)
            });
            commit('dspSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async dspFetchReportGroupedCampaign({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.dspGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.dspGetFilters(),
          ...pager,
          ...getters.currencyConfigQueryGet(),
          ...getters.dspGetProductTableSort()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/ppc/dsp/report/campaign", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('dspSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('dspSetProductTableItems', report);
            commit('dspSetProductTableTotal', total?.pop() ?? {});
            commit('dspSetProductTableMaxCharCount', {
              currency: computeCurrencyMaxCharCount(report, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report)
            });
            commit('dspSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    dspSetDefaultCurrency({
      getters,
      commit
    }) {
      //console.log('getters', getters.currencyConfigQueryGet())
      commit('dspDefaultCurrencySet', getters.currencyConfigQueryGet().currency);
    },
    dspSetPeriod({
      commit
    }, period) {
      commit('dspSetPeriod', period);
    },
    dspSetOverviewPeriod({
      commit
    }, period) {
      commit('dspSetOverviewPeriod', period);
    },
    dspSetPeriodCategory({
      commit
    }, periodCategory) {
      commit('dspSetPeriodCategory', periodCategory);
    },
    dspSetTab({
      commit
    }, tab) {
      commit('dspSetCurrentTab', tab);
    },
    dspSetProductTableGroupBy({
      commit
    }, groupBy) {
      commit('dspSetProductTableGroupBy', groupBy);
    },
    dspSetProductTablePeriod({
      commit
    }, period) {
      commit('dspSetProductTablePeriod', period);
    },
    dspSetProductTableState({
      commit
    }, payload) {
      commit('dspSetProductTableState', payload);
    },
    dspSetProductTablePage({
      commit
    }, page) {
      commit('dspSetProductTablePage', page);
    },
    dspSetProductTablePerPage({
      commit
    }, perPage) {
      commit('dspSetProductTablePerPage', perPage);
    },
    dspSetProductTableTotalPages({
      commit
    }, totalPages) {
      commit('dspSetProductTableTotalPages', totalPages);
    },
    dspSetProductTableGroupByElements({
      commit,
      getters
    }) {
      const {
        sellers,
        marketplaces
      } = getters.dspGetAccountState();
      const {
        SELLER,
        MARKETPLACE,
        LINE_ITEM,
        DSP_CAMPAIGN
      } = GROUP_BY_TAB_ELEMENTS;
      const DEFAULT_TABS = [DSP_CAMPAIGN, LINE_ITEM];
      const prefixTabs = [];
      if (sellers.length > 1) {
        prefixTabs.push(SELLER);
      }
      if (marketplaces.length > 1) {
        prefixTabs.push(MARKETPLACE);
      }
      const suffixTabs = [...DEFAULT_TABS];
      const finalTabs = [...prefixTabs, ...suffixTabs];
      commit("dspSetProductTableGroupByElements", finalTabs);
      commit("dspSetProductTableGroupBy", 0);
    },
    dspIncrementPeriodPage({
      commit
    }) {
      commit('dspIncrementPeriodPage');
    },
    dspSetProductTableSort({
      commit
    }, payload) {
      commit('dspSetProductTableSort', payload);
    },
    async getDspLineItems({
      state,
      getters
    }, payload) {
      const result = await request("/ppc/dsp/filters/line_item", 'POST', {
        ...getters.dspGetFilters(),
        keyword_list: payload?.keyword
      }, false, true, 'cors');
      if (result && result.data && result.data.line_items) {
        let line_items = result.data.line_items;
        return line_items;
      }
    },
    async getDspOrders({
      state,
      getters
    }, payload) {
      const result = await request("/ppc/dsp/filters/order", 'POST', {
        ...getters.dspGetFilters(),
        keyword_list: payload?.keyword
      }, false, true, 'cors');
      if (result && result.data && result.data.orders) {
        let orders = result.data.orders;
        return orders;
      }
    }
  }
};
export default dsp_report;